package org.matthewo.recharts.type

import js.objects.unsafeJso

fun ChartMargin(top: Int, right: Int, bottom: Int, left: Int) = unsafeJso<dynamic> {
    this["top"] = top
    this["right"] = right
    this["bottom"] = bottom
    this["left"] = left
}
